var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"languages"}},[(_vm.loading)?_c('div',{staticClass:"languages-loader"}):_vm._e(),_c('LanguagesAddNewPopup'),_c('LanguagesSelector'),_c('LanguagesFields')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }